import { Box, Skeleton, SvgIconProps, Typography } from '@mui/material';
import { lighten } from '@mui/material/styles';
import React, { ReactNode } from 'react';

function StatCard({
  color,
  bgColor,
  Icon,
  label,
  value,
  percentageProgression,
  progression,
}: {
  bgColor?: string;
  color: string;
  Icon: (props: SvgIconProps) => React.JSX.Element;
  label: ReactNode;
  percentageProgression?: boolean;
  progression?: ReactNode;
  value: ReactNode | undefined;
}): React.JSX.Element {
  return (
    <Box
      borderRadius={2}
      display="flex"
      flexDirection="column"
      gap={1}
      height="100%"
      justifyContent="flex-end"
      padding={2}
      sx={{ backgroundColor: bgColor || lighten(color, 0.8) }}
      width="100%"
    >
      {Icon && <Icon sx={{ color }} />}
      <Box display="flex" flexDirection="column">
        <Typography color="textSecondary" variant="body2">
          {label}
        </Typography>
        <Typography fontWeight={700} variant="h6">
          {value !== undefined ? value : <Skeleton variant="text" width={100} />}{' '}
          {value !== undefined && progression !== undefined && percentageProgression && (
            <Typography noWrap color="textSecondary" fontWeight={400} variant="caption">
              ({progression})
            </Typography>
          )}
        </Typography>
        {value !== undefined && progression !== undefined && !percentageProgression && (
          <Typography color="textSecondary" fontWeight={400} variant="caption">
            {progression}
          </Typography>
        )}
      </Box>
    </Box>
  );
}

export default StatCard;
